import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { firestoreConnect } from 'react-redux-firebase';
import M from 'materialize-css';
import { Redirect } from 'react-router-dom';
import ModalCompanyDialog from '../pyns/ModalCompanyDialog';
import { countryCodes } from '../../config/keys';
import { badgesType } from '../../constants/constants';
import Functions from '../../api/Functions';

const refModal = React.createRef();

function MigratePyns(props) {
  const { auth, companies } = props;
  const [trypStopCompanies, setTrypStopCompanies] = useState([]);
  const [trypStopCompany, setTrypStopCompany] = useState(null);
  const [currentCompanies, setCurrentCompanies] = useState([]);
  const [country, setCountry] = useState('');
  const [company, setCompany] = useState(null);
  const [showProcessText, setShowProcessText] = useState(false);

  const clearFields = () => {
    setTrypStopCompany(null);
    updateCountry('');
    setCompany(null);
  };

  useEffect(() => M.AutoInit(), []);

  useEffect(() => {
    let elems = document.querySelectorAll('select');
    M.FormSelect.init(elems, {});
  }, [company]);

  useEffect(() => {
    if (!companies) return;
    const zonesCompanies = companies.filter((c) => c.type === badgesType.TRYP_STOPS);
    setTrypStopCompanies(zonesCompanies);
  }, [companies]);

  const openCompanyDialog = () => {
    const modal = M.Modal.getInstance(refModal.current);
    modal.open();
  };

  const filterCompanies = (country, companyName) => {
    if (!companies) return;
    let filteredCompanies = companies.filter((company) => {
      return company.countryCode === country && (companyName !== '' ? company.companyName.toLowerCase().includes(companyName.toLowerCase()) : true);
    });
    setCurrentCompanies(filteredCompanies);
  };

  const search = (searchTerm) => filterCompanies(country, searchTerm);

  const updateCountry = (country) => {
    setCountry(country);
    filterCompanies(country, '');
  };

  const addDisplayFieldToPyns = () => {
    setShowProcessText(true);
    Functions.addDisplayFieldToPyns(company.uid, trypStopCompany ? trypStopCompany.uid : null)
      .then(() => {
        M.toast({ html: `Finished updating` });
        clearFields();
      })
      .catch((e) => M.toast({ html: `Error: ${e.message}` }))
      .finally(() => setShowProcessText(false));
  };

  const renderTrypStopSelect = () => {
    if (!trypStopCompanies) return null;
    return (
      <div className="row">
        <div className="input-field col s6">
          <select value={trypStopCompany ? trypStopCompany.id || '' : ''} onChange={(e) => setTrypStopCompany(trypStopCompanies[e.target.value])}>
            <option value="">Select a Tryp Stop Company</option>
            {Object.keys(trypStopCompanies).map((key) => (
              <option key={key} value={key}>
                {trypStopCompanies[key].companyName}
              </option>
            ))}
          </select>
          <label>Tryp Stop Company</label>
        </div>
      </div>
    );
  };

  const renderCompaniesSelect = () => (
    <div className="row">
      {renderCountrySelect()}
      {renderCompanyInput()}
    </div>
  );

  const renderCountrySelect = () => (
    <div className="row">
      <div className="input-field col s6">
        <select
          value=""
          onChange={(e) => {
            updateCountry(e.target.value);
          }}>
          <option value="">Add country code</option>
          {Object.keys(countryCodes).map((country) => (
            <option key={country} value={country}>
              {country}
            </option>
          ))}
        </select>
      </div>
    </div>
  );

  const renderCompanyInput = () => (
    <div className="row">
      <div className="input-field col s6">
        <p className="col s2" style={{ textAlign: 'right' }}>
          Company:
        </p>
        <div className="col s8">
          <input type="text" disabled value={(company && company.uid) || ''} onChange={() => {}} />
        </div>
        <div className="col s1">
          <button className="waves-effect waves-light btn-small" onClick={() => openCompanyDialog()}>
            Select company
          </button>
        </div>
      </div>
    </div>
  );

  if (!auth.uid) return <Redirect to="/signin" />;
  return (
    <div className="container">
      <ModalCompanyDialog refModal={refModal} search={search} currentCompanies={currentCompanies} setUidCompany={() => {}} setCompany={setCompany} />
      <div className="title-section">Add display field to pyns by company</div>
      <br />
      {renderCompaniesSelect()}
      {company && company.type === badgesType.TRYP_STOPS && renderTrypStopSelect()}
      <div className="row">
        <button className="col s2 waves-effect waves-light btn-small" onClick={() => addDisplayFieldToPyns()}>
          Update
        </button>
        {showProcessText && <div className="col s2">Processing...</div>}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    companies: state.firestore.ordered.companies,
    trypStopCompanies: state.firestore.data['trypStopCompanies'],
    auth: state.firebase.auth,
  };
};

export default compose(firestoreConnect([{ collection: 'companies', orderBy: ['companyName', 'asc'] }]), connect(mapStateToProps))(MigratePyns);
